import {createSelector} from 'reselect';
import {getSettings} from './selectors';

const getIsUKToEU = state => state.deliveryOption.ukToEU;

export default createSelector(
  [getIsUKToEU, getSettings],
  (isUKToEU, settings) => !!(isUKToEU && settings.requires_t_and_c_consent),
);
